/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs */

const en_keyword_optimizer_generate_cta_upgrade_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI rewording is available on Student and Pro plans. Upgrade to unlock.`)
};

const de_keyword_optimizer_generate_cta_upgrade_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Umformulierung ist im Student- und Pro-Tarif verfügbar. Upgrade, um sie freizuschalten.`)
};

const fr_keyword_optimizer_generate_cta_upgrade_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La reformulation IA est disponible sur les plans Student et Pro. Passez au niveau supérieur pour la débloquer.`)
};

const es_keyword_optimizer_generate_cta_upgrade_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La reformulación con IA está disponible en los planes Student y Pro. Mejora tu plan para desbloquearla.`)
};

const it_keyword_optimizer_generate_cta_upgrade_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La riformulazione IA è disponibile nei piani Student e Pro. Aggiorna per sbloccarla.`)
};

const nl_keyword_optimizer_generate_cta_upgrade_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-herformulering is beschikbaar op Student- en Pro-abonnementen. Upgrade om te ontgrendelen.`)
};

const pl_keyword_optimizer_generate_cta_upgrade_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeredagowanie AI jest dostępne w planach Student i Pro. Zaktualizuj plan, aby odblokować.`)
};

const fi_keyword_optimizer_generate_cta_upgrade_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-uudelleenmuotoilu on saatavilla Student- ja Pro-tilauksilla. Päivitä tilaus avataksesi sen.`)
};

const da_keyword_optimizer_generate_cta_upgrade_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-omformulering er tilgængelig på Student- og Pro-abonnementer. Opgrader for at låse op.`)
};

const sv_keyword_optimizer_generate_cta_upgrade_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-omformulering är tillgängligt på Student- och Pro-planer. Uppgradera för att låsa upp.`)
};

/**
* | output |
* | --- |
* | "AI rewording is available on Student and Pro plans. Upgrade to unlock." |
*
* @param {Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_generate_cta_upgrade_hint = /** @type {((inputs?: Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Generate_Cta_Upgrade_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_generate_cta_upgrade_hint(inputs)
	if (locale === "fr") return fr_keyword_optimizer_generate_cta_upgrade_hint(inputs)
	if (locale === "es") return es_keyword_optimizer_generate_cta_upgrade_hint(inputs)
	if (locale === "it") return it_keyword_optimizer_generate_cta_upgrade_hint(inputs)
	if (locale === "nl") return nl_keyword_optimizer_generate_cta_upgrade_hint(inputs)
	if (locale === "pl") return pl_keyword_optimizer_generate_cta_upgrade_hint(inputs)
	if (locale === "fi") return fi_keyword_optimizer_generate_cta_upgrade_hint(inputs)
	if (locale === "da") return da_keyword_optimizer_generate_cta_upgrade_hint(inputs)
	if (locale === "sv") return sv_keyword_optimizer_generate_cta_upgrade_hint(inputs)
	return en_keyword_optimizer_generate_cta_upgrade_hint(inputs)
});